type Props = {
  children?: React.ReactNode;
  classes?: string;
};

const CheckboxList = ({ children, classes = 'flex flex-col gap-16' }: Props) => {
  return (
    <div className={classes} role="listbox">
      {children}
    </div>
  );
};

export default CheckboxList;
